import { Pipe, PipeTransform } from '@angular/core';
import { JOB_LABELS } from '../../../services/job_labels.service';

@Pipe({
  name: 'buyingPersonasDisplayQuery'
})
export class BuyingPersonasDisplayQueryPipe implements PipeTransform {
  transform(query: Record<string, any>): Array<{ label: string; value: string }> {
    const jobTitle: string = (query?.job_title || '')
      .split(',')
      .map((value: string) => value.trim())
      .filter(Boolean)
      .join(', ');

    const jobLevels: string = (query?.job_levels || '')
      .split(',')
      .map((key: string) => JOB_LABELS.levels[key])
      .filter(Boolean)
      .join(', ');

    const jobDepartments: string[] = (query?.job_departments || '')
      .split(',')
      .map((key: string) => JOB_LABELS.departments[key])
      .filter(Boolean);

    const subDepartmentsInput: string[] = Array.isArray(query?.job_sub_departments)
      ? query.job_sub_departments
      : (query?.job_sub_departments || '')
          .split(',')
          .map((value: string) => value.trim());

    const jobSubDepartments: string[] = subDepartmentsInput
      .filter(Boolean)
      .map((value: string) => value.replace(/~~/g, '>'));

    const departmentValue: string = [...jobDepartments, ...jobSubDepartments].filter(Boolean).join(', ');

    const lines: Array<{ label: string; value: string }> = [];

    if (jobLevels) {
      lines.push({ label: 'Level', value: jobLevels });
    }

    if (departmentValue) {
      lines.push({ label: 'Department', value: departmentValue });
    }

    if (jobTitle) {
      lines.push({ label: 'Title', value: jobTitle });
    }

    return lines;
  }
}
